// removed by extract-text-webpack-plugin
module.exports = {"alert":"_2Ra6FuBMtBiI5aFIXg17Xt","prompt":"_1naees8p3xnhSpuPJ2s2XC"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/Alert/Alert.css
// module id = 981
// module chunks = 58